/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdatePlanDto = {
    /**
     * Platform commission percentage (0-100)
     */
    commissionPercentage?: number;
    /**
     * Who this plan is ideal for
     */
    idealFor?: string;
    /**
     * Array of feature descriptions (replaces existing)
     */
    features?: Array<string>;
    /**
     * Session limit (null = unlimited)
     */
    maxSessions?: number;
    /**
     * Sessions per week cap (null = unlimited)
     */
    sessionsPerWeek?: number;
    /**
     * Show "Most Popular" badge
     */
    isMostPopular?: boolean;
    /**
     * Admin toggle: plan visible/purchasable in app
     */
    isActive?: boolean;
    /**
     * Lifecycle state: active | inactive | grandfathered
     */
    planStatus?: UpdatePlanDto.planStatus;
};
export namespace UpdatePlanDto {
    /**
     * Lifecycle state: active | inactive | grandfathered
     */
    export enum planStatus {
        ACTIVE = 'active',
        INACTIVE = 'inactive',
        GRANDFATHERED = 'grandfathered',
    }
}

